import React, { useEffect } from "react"
import styled from "@emotion/styled"
import { FlexContainer } from "../../styled/layout.styled"
import { P } from "../../styled/typography.styled"
import aos from "aos"
import "aos/dist/aos.css"

const StyledH4 = styled.h4`
  font-size: 13px;
  line-height: 1.1em;
  position: relative;
  float: left;
  margin: 0 0 4px;
  font-family: "Poppins", Helvetica, sans-serif;
  font-weight: 600;
  font-style: normal;
  color: #f5f5f5;
`

const StyledP = styled(P)`
  font-size: 11px;
  line-height: 1.1em;
  position: relative;
  float: right;
  margin: 0 0 4px;
  color: #888;
`

const StyledLinear = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  height: 12px;
  background-color: transparent;
  border: 2px solid #444;
  border-radius: 8px;
  box-sizing: border-box;
`
const StyledPercentage = styled.div`
  background-color: #007ced;
  max-width: ${({ skillsPercent }) => skillsPercent};
  border: 2px solid #222;
  border-radius: 9px;
  height: 4px;
  padding: 0;
`

const SkillsLinear = ({ title, skillsPercent }) => {
  useEffect(() => {
    aos.init({ duration: 500 })
  }, [])

  return (
    <FlexContainer flexDirection="column" width="100%" margin="0 0 15px 0">
      <FlexContainer width="100%" justifyContent="space-between">
        <StyledH4>{title}</StyledH4>
        <StyledP>{skillsPercent}</StyledP>
      </FlexContainer>
      <StyledLinear>
        <StyledPercentage
          data-aos="custom-animation"
          data-aos-anchor-placement="top-bottom"
          data-aos-once="false"
          skillsPercent={skillsPercent}
        />
      </StyledLinear>
    </FlexContainer>
  )
}

export default SkillsLinear
